import 'public/css/product_public.scss'

import 'public/img/contact.png'
import 'public/img/logo.png'
import 'public/img/peek_pro.png'
import 'public/img/logo-bird.png'

import 'public/img/logo-white.png'
import 'public/img/product-bg.png'
import 'public/img/profile-bg.png'
import 'public/img/profile-logo.png'
import 'public/img/icon-api-connected.png'
import 'public/img/lightning-icon.png'
import 'public/img/arrow-left.png'
import 'public/img/staticmap.png'
import 'public/img/landing_page/headout-logo.png'
import 'public/img/landing_page/headout-icon.png'
import 'public/img/landing_page/headout-1.png'
import 'public/img/landing_page/headout-2.png'
import 'public/img/landing_page/headout-3.png'
import 'public/img/landing_page/headout-arrow.png'

import 'public/img/locations/san-francisco.svg'
import 'public/img/landing_page/where-travel-web.png'
import 'public/img/landing_page/hiw1-rp.jpg'
import 'public/img/landing_page/hiw2-rp.jpg'
import 'public/img/landing_page/hiw3-rp.jpg'
import 'public/img/landing_page/hiw4-rp.jpg'
import 'public/img/landing_page/wt-what-is-magpie.png'
import 'public/img/landing_page/GettinLocal-1.png'
import 'public/img/landing_page/GettinLocal-2.jpg'
import 'public/img/landing_page/GettinLocal-4.png'

import 'public/img/sponsors/Arival-Logo-White.jpg'
import 'public/img/sponsors/Tour.jpg'
import 'public/img/sponsors/tripschool.png'
import 'public/img/sponsors/ventatra.jpg'
import 'public/img/walks-logo.png'
import 'public/img/banner.png'
import 'public/img/operator-banner.png'
import 'public/img/operator-banner.jpg'
import 'public/img/tripadvisor_background.svg'
import 'public/img/background_header.png'
import 'public/img/google-round-01.svg'
import 'public/img/facebook-round-01.svg'
import 'public/img/instagram-round-01.svg'
import 'public/img/linkedin-round-01.svg'
import 'public/img/tiktok-round-01.svg'
import 'public/img/tripadvisor-round-01.svg'
import 'public/img/twitter-round-01.svg'
import 'public/img/youtube-round-01.svg'
import 'public/img/google-ttd-01.svg'
import 'public/img/google-ttd.png'
import 'public/img/madame-tussauds-logo.svg'
import 'public/img/city-experiences-logo.svg'
import 'public/img/big-bus-tours-logo.svg'
import 'public/img/san-diego-zoo-logo.svg'
import 'public/img/london-eye-logo.svg'
import 'public/img/go-city-logo.svg'
import 'public/img/top-of-the-rock-logo.svg'
import 'public/img/skyline-new-logo.svg'
import 'public/img/maverick-logo.svg'
import 'public/img/city-wonders-logo.svg'
import 'public/img/one-world-observatory-logo.svg'



import 'public/img/market_pulse/market_pulse-1.svg'
import 'public/img/market_pulse/market_pulse-2.svg'
import 'public/img/market_pulse/market_pulse-3.svg'

import 'public/img/Gondola-WHITE-01.svg'
